<app-hierarchy-filter (applied)="onFiltersApplied()" (cleared)="onFiltersCleared()"></app-hierarchy-filter>

<div class="updated-dashboard-wrapper">

    <!-- TOP HEADER / FILTER BAR -->
    <header class="ud-top-bar">

        <!-- Center Filters & Rural/Urban -->
        <div class="ud-filters-group">
            <div class="ud-filter-item">
                <label class="ud-filter-label">{{ langService.currentLang === 'mr' ? 'आर्थिक वर्ष' : 'Financial Year'
                    }}</label>
                <dx-select-box [items]="YearsList" [(value)]="FinancialYearRef" displayExpr="p.short_name"
                    valueExpr="p.id" [placeholder]="CurrentFinancialYear || '2026-2027'"
                    (onValueChanged)="onYearChanged($event)" [searchEnabled]="true" class="ud-select-box">
                </dx-select-box>
            </div>

            <div class="ud-filter-item">
                <label class="ud-filter-label">{{ langService.currentLang === 'mr' ? 'फिल्टर प्रकार' : 'Filter Type'
                    }}</label>
                <dx-select-box [items]="FilterList" [(value)]="ReportFilterType" [displayExpr]="getTranslatedName"
                    valueExpr="Ref" placeholder="{{ 'REPORT_PLACEHOLDERS.Select' | translate }}"
                    (onValueChanged)="OnFilterChange($event.value)" [searchEnabled]="true" class="ud-select-box">
                </dx-select-box>
            </div>

            <!-- Half Year (Conditional) -->
            <div class="ud-filter-item" *ngIf="IsShowHalfYear">
                <label class="ud-filter-label">{{ 'FILTER_LABELS.HalfYear' | translate }}</label>
                <dx-select-box [items]="HalfYearList" [(value)]="HalfYearType" [displayExpr]="getTranslatedName"
                    valueExpr="Ref" [placeholder]="'REPORT_PLACEHOLDERS.SelectHalfYear' | translate"
                    (onValueChanged)="onHalfYearChanged($event)" [searchEnabled]="true" class="ud-select-box">
                </dx-select-box>
            </div>

            <!-- Quarter (Conditional) -->
            <div class="ud-filter-item" *ngIf="IsShowQuarter">
                <label class="ud-filter-label">{{ 'FILTER_LABELS.Quarter' | translate }}</label>
                <dx-select-box [items]="QuarterList" [(value)]="QuarterlyYearType" [displayExpr]="getTranslatedName"
                    valueExpr="Ref" [placeholder]="'REPORT_PLACEHOLDERS.SelectQuarter' | translate"
                    (onValueChanged)="onQuarterChanged($event)" [searchEnabled]="true" class="ud-select-box">
                </dx-select-box>
            </div>

            <!-- Month (Conditional) -->
            <div class="ud-filter-item" *ngIf="IsShowMonth">
                <label class="ud-filter-label">{{ 'FILTER_LABELS.Month' | translate }}</label>
                <dx-select-box [items]="MonthList" [(value)]="Month" [displayExpr]="getTranslatedName" valueExpr="Ref"
                    [placeholder]="'REPORT_PLACEHOLDERS.SelectMonth' | translate"
                    (onValueChanged)="onMonthChanged($event)" [searchEnabled]="true" class="ud-select-box">
                </dx-select-box>
            </div>

            <!-- Rural / Urban Toggle Switch -->
            <div class="ud-area-toggle-wrap">
                <div class="ud-area-toggle">
                    <button type="button" class="ud-area-btn" [class.active]="selectedArea === 'rural'"
                        (click)="onAreaChange('rural')">
                        {{ langService.currentLang === 'mr' ? 'ग्रामीण' : 'Rural' }}
                    </button>
                    <button type="button" class="ud-area-btn" [class.active]="selectedArea === 'urban'"
                        (click)="onAreaChange('urban')">
                        {{ langService.currentLang === 'mr' ? 'शहरी' : 'Urban' }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Right Action Controls: Refresh Button & Filter Button -->
        <div class="ud-user-section">
            <!-- REFRESH BUTTON WRAPPER WITH USER GUIDE CALLOUT -->
            <div class="refresh-btn-wrapper">
                <button type="button" class="dashboard-refresh-btn" [class.highlight-pulse]="isDataStale"
                    [class.refreshing]="isRefreshing" [class.just-updated]="justUpdated" [disabled]="isRefreshing"
                    (click)="refreshDashboard()" [title]="isDataStale 
                        ? (langService.currentLang === 'mr' ? 'नवीन माहिती उपलब्ध आहे - रिफ्रेश करा' : 'New data available - Click to refresh')
                        : (langService.currentLang === 'mr' ? 'माहिती अद्यतनित करा' : 'Refresh Dashboard')">

                    <span class="refresh-icon-wrap" [class.spinning]="isRefreshing">
                        <svg class="refresh-svg" viewBox="0 0 24 24" width="18" height="18" fill="none"
                            stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.19" />
                        </svg>
                    </span>

                    <span class="refresh-label">
                        {{ isRefreshing
                        ? (langService.currentLang === 'mr' ? 'अद्यतनित...' : 'Refreshing...')
                        : (langService.currentLang === 'mr' ? 'रिफ्रेश' : 'Refresh') }}
                    </span>

                    <!-- Stale Attention Pulse Badge / Dot -->
                    <span *ngIf="isDataStale" class="refresh-badge-dot">
                        <span class="badge-ping"></span>
                        <span class="badge-core"></span>
                    </span>
                </button>

                <!-- USER GUIDE POINTER (Points directly to the refresh button) -->
                <div *ngIf="isDataStale && !isRefreshing && !isGuideDismissed" class="refresh-user-guide"
                    (click)="refreshDashboard()"
                    [title]="langService.currentLang === 'mr' ? 'रिफ्रेश करण्यासाठी येथे क्लिक करा' : 'Click to refresh data'">
                    <div class="guide-pointer-arrow">
                        <div class="guide-pointer-badge">
                            <svg class="guide-up-arrow" viewBox="0 0 24 24" width="16" height="16" fill="none"
                                stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="12" y1="19" x2="12" y2="5"></line>
                                <polyline points="5 12 12 5 19 12"></polyline>
                            </svg>
                        </div>
                    </div>
                    <div class="guide-card">
                        <div class="guide-header">
                            <span class="guide-pulse-beacon"></span>
                            <span class="guide-title">
                                {{ langService.currentLang === 'mr' ? 'नवीन माहिती उपलब्ध!' : 'Updates Available!' }}
                            </span>
                            <button type="button" class="guide-close-btn" (click)="dismissGuide($event)"
                                [title]="langService.currentLang === 'mr' ? 'मार्गदर्शक बंद करा' : 'Close Guide'">
                                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                        <div class="guide-desc">
                            {{ langService.currentLang === 'mr' ? 'नवीनतम आकडेवारीसाठी येथे क्लिक करा' : 'Click here to
                            refresh latest data' }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Hierarchy Filter Button -->
            <button type="button" class="ud-funnel-btn" (click)="openFilterPanel()"
                [title]="langService.currentLang === 'mr' ? 'फिल्टर उघडा' : 'Open Filters'">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="#d82b6b">
                    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                </svg>
            </button>
        </div>
    </header>

    <!-- EMPTY STATE FOR URBAN -->
    <div *ngIf="isUrbanNoData" class="ud-empty-urban">
        <div class="ud-empty-card">
            <span class="ud-empty-icon">📊</span>
            <h3>{{ langService.currentLang === 'mr' ? 'शहरी क्षेत्रासाठी कोणतीही माहिती उपलब्ध नाही' : 'No data
                available for Urban area' }}</h3>
            <p>{{ langService.currentLang === 'mr' ? 'कृपया ग्रामीण क्षेत्र निवडा' : 'Please select Rural area to view
                dashboard records' }}</p>
            <button class="ud-back-rural-btn" (click)="onAreaChange('rural')">{{ langService.currentLang === 'mr' ?
                'ग्रामीण क्षेत्रावर जा' : 'Switch to Rural' }}</button>
        </div>
    </div>

    <ng-container *ngIf="!isUrbanNoData">

        <!-- WELCOME GREETING BANNER -->
        <section class="ud-welcome-banner">
            <div class="ud-welcome-left">
                <div class="ud-tai-avatar">
                    <img src="assets/dashboard_icons/asha_profile_image.png" alt="Asha Tai" class="ud-tai-img">
                </div>
                <div class="ud-welcome-content">
                    <h2 class="ud-welcome-heading">
                        {{ langService.currentLang === 'mr' ? 'नमस्ते, आशा ताई! 👋' : 'Hello, Asha Tai! 👋' }}
                    </h2>
                    <p class="ud-welcome-sub">
                        {{ langService.currentLang === 'mr' ? 'आपला दिवस चांगला जावो!' : 'Have a great day!' }}
                    </p>
                </div>
            </div>

            <div class="ud-welcome-right">
                <div class="ud-date-badge">
                    <div class="ud-cal-icon-wrap">
                        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#d82b6b" stroke-width="2">
                            <rect x="3" y="4" width="18" height="18" rx="3" ry="3"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                    </div>
                    <div class="ud-date-text">
                        <span class="ud-date-num">{{ todayDateFormatted }}</span>
                        <span class="ud-date-day">{{ todayDayOfWeek }}</span>
                    </div>
                </div>
            </div>
        </section>

        <!-- TODAY'S TASK -->
        <section class="ud-section ud-today-tasks-section">
            <div class="ud-tasks-header">
                <div class="ud-tasks-header-left">
                    <span class="ud-section-bar"></span>
                    <h3 class="ud-section-title">
                        {{ langService.currentLang === 'mr' ? "आजचे काम" : "Today's Task" }}
                    </h3>
                    <span class="ud-tasks-total-badge" *ngIf="allTodayTasks && allTodayTasks.length > 0">
                        {{ totalTodayTasksCount }}
                    </span>
                </div>

                <!-- View All: only when more than 3 tasks -->
                <button type="button" class="ud-tasks-view-all-btn" *ngIf="hasMoreTasks" (click)="onViewAllTasks()">
                    <span>{{ langService.currentLang === 'mr' ? 'सर्व पहा' : 'View All' }}</span>
                    <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5"
                        stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </button>
            </div>

            <div class="ud-task-card">
                <!-- First 3 task rows -->
                <ng-container *ngIf="todayTasks && todayTasks.length > 0; else emptyTasksTemplate">
                    <div class="ud-task-row" *ngFor="let task of todayTasks; let last = last"
                        [class.border-dotted]="!last">
                        <div class="ud-task-info">
                            <div class="ud-task-icon-circle">
                                <img *ngIf="task.iconImg" [src]="task.iconImg" [alt]="task.title">
                                <span *ngIf="!task.iconImg" class="ud-task-emoji">{{ task.emoji }}</span>
                            </div>
                            <span class="ud-task-name">
                                {{ langService.currentLang === 'mr' ? task.titleMr : task.title }}
                            </span>
                        </div>

                        <div class="ud-task-count-wrap">
                            <span class="ud-task-count">{{ task.count }}</span>
                        </div>

                        <div class="ud-task-action-wrap">
                            <button type="button" class="ud-view-btn" (click)="onTaskClick(task.id)">
                                <span>{{ langService.currentLang === 'mr' ? 'तपशील पहा' : 'View Details' }}</span>
                                <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor"
                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </button>
                        </div>
                    </div>
                </ng-container>

                <!-- Empty state when no tasks -->
                <ng-template #emptyTasksTemplate>
                    <div class="ud-tasks-empty-state">
                        <div class="ud-tasks-empty-icon-wrap">
                            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#E83E6C"
                                stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="3" y="4" width="18" height="18" rx="3" ry="3"></rect>
                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                <line x1="3" y1="10" x2="21" y2="10"></line>
                                <path d="m9 16 2 2 4-4"></path>
                            </svg>
                        </div>
                        <h4 class="ud-tasks-empty-title">
                            {{ langService.currentLang === 'mr' ? 'आज कोणतेही काम नाही' : 'No tasks for today' }}
                        </h4>
                        <p class="ud-tasks-empty-subtitle">
                            {{ langService.currentLang === 'mr' ? 'सर्व कामे पूर्ण झाली आहेत.' : "You're all caught up."
                            }}
                        </p>
                    </div>
                </ng-template>
            </div>
        </section>

        <!-- KEY FIGURES -->
        <section class="ud-section">
            <div class="ud-section-header">
                <span class="ud-section-bar"></span>
                <h3 class="ud-section-title">
                    {{ langService.currentLang === 'mr' ? 'महत्त्वाचे आकडे' : 'Key Figures' }}
                </h3>
                <svg class="ud-grid-title-icon" viewBox="0 0 24 24" width="18" height="18" fill="#d82b6b">
                    <path
                        d="M4 4h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zM4 10h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zM4 16h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4z" />
                </svg>
            </div>

            <!-- Row 1: 2 Wide Cards -->
            <div class="ud-kf-row-2">
                <!-- Population -->
                <div class="ud-kf-card pink-bg" (click)="onKeyFigureClick('population')">
                    <div class="ud-kf-card-top">
                        <div class="ud-kf-icon-box white-bg">
                            <img src="assets/dashboard_icons/total_population_covered_by_asha.png"
                                alt="Total Population">
                        </div>
                        <span class="ud-kf-label">
                            {{ langService.currentLang === 'mr' ? 'आशा ताईंनी समाविष्ट केलेली एकूण लोकसंख्या' : 'Total
                            Population Covered By ASHA' }}
                        </span>
                    </div>
                    <div class="ud-kf-card-bottom">
                        <span class="ud-kf-value">{{ (totalPopulationCoveredByAsha || 0) | number }}</span>
                        <div class="ud-kf-meta">
                            <div class="ud-kf-badge-wrap">
                                <span class="ud-trend-pill"
                                    [ngClass]="(totalPopulationPercentage || 0) >= 0 ? 'green' : 'red'">{{
                                    formatTrend(totalPopulationPercentage) }}</span>
                                <span class="ud-circle-arrow">
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                                        stroke-width="2.5">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </span>
                            </div>
                            <span class="ud-kf-date">{{ asOnDate }}</span>
                        </div>
                    </div>
                </div>

                <!-- Families -->
                <div class="ud-kf-card blue-bg" (click)="onKeyFigureClick('families')">
                    <div class="ud-kf-card-top">
                        <div class="ud-kf-icon-box white-bg">
                            <img src="assets/dashboard_icons/no_of_families.png" alt="Number Of Families">
                        </div>
                        <span class="ud-kf-label">
                            {{ langService.currentLang === 'mr' ? 'कुटुंबांची संख्या' : 'Number Of Families' }}
                        </span>
                    </div>
                    <div class="ud-kf-card-bottom">
                        <span class="ud-kf-value">{{ (noOfFamilies || 0) | number }}</span>
                        <div class="ud-kf-meta">
                            <div class="ud-kf-badge-wrap">
                                <span class="ud-trend-pill"
                                    [ngClass]="(noOfFamiliesPercentage || 0) >= 0 ? 'green' : 'red'">{{
                                    formatTrend(noOfFamiliesPercentage) }}</span>
                                <span class="ud-circle-arrow">
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                                        stroke-width="2.5">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </span>
                            </div>
                            <span class="ud-kf-date">{{ asOnDate }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Row 2: 3 Cards -->
            <div class="ud-kf-row-3">
                <!-- Children 0-6 Years -->
                <div class="ud-kf-card orange-bg" (click)="onKeyFigureClick('children')">
                    <div class="ud-kf-card-top">
                        <div class="ud-kf-icon-box white-bg">
                            <img src="assets/dashboard_icons/number_of_children_0_6_year.png" alt="Children">
                        </div>
                        <span class="ud-kf-label">
                            {{ langService.currentLang === 'mr' ? 'मुलांची संख्या (०-६ वर्षे)' : 'Number Of Children
                            (0-6 Years)' }}
                        </span>
                    </div>
                    <div class="ud-kf-card-bottom">
                        <span class="ud-kf-value">{{ (childrenBelowSixYears || 0) | number }}</span>
                        <div class="ud-kf-meta">
                            <div class="ud-kf-badge-wrap">
                                <span class="ud-trend-pill"
                                    [ngClass]="(childrenBelowFiveYearsPercentage || 0) >= 0 ? 'green' : 'red'">{{
                                    formatTrend(childrenBelowFiveYearsPercentage) }}</span>
                                <span class="ud-circle-arrow">
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                                        stroke-width="2.5">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </span>
                            </div>
                            <span class="ud-kf-date">{{ asOnDate }}</span>
                        </div>
                    </div>
                </div>

                <!-- Members Above 30 Years -->
                <div class="ud-kf-card light-blue-bg" (click)="onKeyFigureClick('above30')">
                    <div class="ud-kf-card-top">
                        <div class="ud-kf-icon-box white-bg">
                            <img src="assets/dashboard_icons/member_above_30_year.png" alt="Above 30">
                        </div>
                        <span class="ud-kf-label">
                            {{ langService.currentLang === 'mr' ? '३० वर्षांवरील सदस्य' : 'Members Above 30 Years' }}
                        </span>
                    </div>
                    <div class="ud-kf-card-bottom">
                        <span class="ud-kf-value">{{ (membersAboveThirtyYears || 0) | number }}</span>
                        <div class="ud-kf-meta">
                            <div class="ud-kf-badge-wrap">
                                <span class="ud-trend-pill"
                                    [ngClass]="(membersAboveThirtyYearsPercentage || 0) >= 0 ? 'green' : 'red'">{{
                                    formatTrend(membersAboveThirtyYearsPercentage) }}</span>
                                <span class="ud-circle-arrow">
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                                        stroke-width="2.5">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </span>
                            </div>
                            <span class="ud-kf-date">{{ asOnDate }}</span>
                        </div>
                    </div>
                </div>

                <!-- Members Above 65 Years -->
                <div class="ud-kf-card dark-pink-bg" (click)="onKeyFigureClick('above65')">
                    <div class="ud-kf-card-top">
                        <div class="ud-kf-icon-box white-bg">
                            <img src="assets/dashboard_icons/member_above_65_year.png" alt="Members Above 65 Years">
                        </div>
                        <span class="ud-kf-label">
                            {{ langService.currentLang === 'mr' ? '६५ वर्षांवरील सदस्य' : 'Members Above 65 Years' }}
                        </span>
                    </div>
                    <div class="ud-kf-card-bottom">
                        <span class="ud-kf-value">{{ (membersAboveSixtyFiveYears || 0) | number }}</span>
                        <div class="ud-kf-meta">
                            <div class="ud-kf-badge-wrap">
                                <span class="ud-trend-pill"
                                    [ngClass]="(membersAboveSixtyFiveYearsPercentage || 0) >= 0 ? 'green' : 'red'">{{
                                    formatTrend(membersAboveSixtyFiveYearsPercentage) }}</span>
                                <span class="ud-circle-arrow">
                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                                        stroke-width="2.5">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </span>
                            </div>
                            <span class="ud-kf-date">{{ asOnDate }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- OVERVIEW SECTION -->
        <section class="ud-section">
            <div class="ud-section-header">
                <span class="ud-section-bar"></span>
                <h3 class="ud-section-title">
                    {{ langService.currentLang === 'mr' ? 'आढावा' : 'Overview' }}
                </h3>
            </div>

            <div class="ud-overview-grid">

                <!-- 1. FAMILY REGISTRATION -->
                <div class="ud-card">
                    <div class="ud-card-header">
                        <div class="ud-card-title-wrap">
                            <span class="ud-card-icon-badge pink-soft">
                                <img src="assets/dashboard_icons/family_registration.png" alt="Family Registration">
                            </span>
                            <span class="ud-card-title">{{ langService.currentLang === 'mr' ? 'कुटुंब नोंदणी' : 'Family
                                Registration' }}</span>
                        </div>
                        <div class="ud-card-header-right">
                            <span class="ud-card-highlight-num">{{ familyTotalFamilies || 0 }}</span>
                            <span class="ud-card-sublabel">{{ langService.currentLang === 'mr' ? 'एकूण कुटुंबे' : 'Total
                                Families' }}</span>
                            <span class="ud-card-date">{{ asOnDate }}</span>
                        </div>
                    </div>

                    <div class="ud-card-body">
                        <div class="ud-family-dual-wrap">
                            <!-- 1. Left Donut: Registration status (Approved & Pending) -->
                            <div class="ud-family-section">
                                <h4 class="ud-family-section-title">
                                    {{ langService.currentLang === 'mr' ? 'नोंदणी स्थिती' : 'Registration status' }}
                                </h4>

                                <div class="ud-donut-chart-box ud-family-donut-box"
                                    (mouseleave)="onDonutMouseLeave('familyStatus')">
                                    <dx-pie-chart [dataSource]="familyStatusData" [palette]="familyStatusPalette"
                                        [customizePoint]="customizePiePoint" type="doughnut" [innerRadius]="0.68"
                                        [size]="{ height: 135, width: 135 }"
                                        (onPointClick)="onFamilyStatusChartPointClick($event)"
                                        (onPointHoverChanged)="onDonutPointHoverChanged('familyStatus', $event)">
                                        <dxo-size [height]="135" [width]="135"></dxo-size>
                                        <dxo-animation [enabled]="true" [duration]="600"
                                            easing="easeOutCubic"></dxo-animation>
                                        <dxo-adaptive-layout [width]="0" [height]="0"
                                            [keepLabels]="false"></dxo-adaptive-layout>
                                        <dxo-margin [top]="0" [bottom]="0" [left]="0" [right]="0"></dxo-margin>
                                        <dxi-series argumentField="name" valueField="value" tagField="color"
                                            type="doughnut" [innerRadius]="0.68">
                                            <dxo-label [visible]="false"></dxo-label>
                                        </dxi-series>
                                        <dxo-tooltip [enabled]="true" container="body" [zIndex]="999999"
                                            [customizeTooltip]="customizeTooltip"
                                            color="rgba(15, 23, 42, 0.94)" [cornerRadius]="8" [paddingTopBottom]="7"
                                            [paddingLeftRight]="11">
                                            <dxo-border color="rgba(255, 255, 255, 0.16)" [width]="1"></dxo-border>
                                            <dxo-shadow [blur]="12" color="rgba(0, 0, 0, 0.35)" [offsetX]="0"
                                                [offsetY]="4"></dxo-shadow>
                                            <dxo-font color="#ffffff" [size]="12"></dxo-font>
                                        </dxo-tooltip>
                                        <dxo-legend [visible]="false"></dxo-legend>
                                        <dxo-export [enabled]="false"></dxo-export>
                                    </dx-pie-chart>
                                    <div class="ud-donut-center-text ud-family-center"
                                        [class.ud-center-hidden]="hoveredDonut['familyStatus']">
                                        <span class="ud-family-center-val">{{ (familyTotalFamilies || 0) | number
                                            }}</span>
                                        <span class="ud-family-center-sub">{{ langService.currentLang === 'mr' ?
                                            'नोंदणीकृत कुटुंबे' : 'Family Registered' }}</span>
                                    </div>
                                </div>

                                <!-- Status Cards: Approved & Pending -->
                                <div class="ud-family-pills-row">
                                    <div class="ud-family-pill pink" (click)="onFamilyClick('Approved')">
                                        <div class="ud-pill-top">
                                            <span class="ud-pill-dot pink"></span>
                                            <span class="ud-pill-lbl">{{ langService.currentLang === 'mr' ? 'मंजूर' :
                                                'Approved' }}</span>
                                            <span class="ud-pill-arr">
                                                <svg viewBox="0 0 24 24" width="12" height="12" fill="none"
                                                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                                    stroke-linejoin="round">
                                                    <polyline points="9 18 15 12 9 6"></polyline>
                                                </svg>
                                            </span>
                                        </div>
                                        <span class="ud-pill-big-val">{{ (familyApprovedTotal || 0) | number }}</span>
                                    </div>

                                    <div class="ud-family-pill blue" (click)="onFamilyClick('Pending')">
                                        <div class="ud-pill-top">
                                            <span class="ud-pill-dot blue"></span>
                                            <span class="ud-pill-lbl">{{ langService.currentLang === 'mr' ? 'प्रलंबित' :
                                                'Pending' }}</span>
                                            <span class="ud-pill-arr">
                                                <svg viewBox="0 0 24 24" width="12" height="12" fill="none"
                                                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                                    stroke-linejoin="round">
                                                    <polyline points="9 18 15 12 9 6"></polyline>
                                                </svg>
                                            </span>
                                        </div>
                                        <span class="ud-pill-big-val">{{ (familyPendingTotal || 0) | number }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Vertical Dashed Divider Matching Figma -->
                            <div class="ud-family-divider"></div>

                            <!-- 2. Right Donut: Approved families by origin (Native & Migrated) -->
                            <div class="ud-family-section">
                                <h4 class="ud-family-section-title">
                                    {{ langService.currentLang === 'mr' ? 'मूळानुसार मंजूर कुटुंबे' : 'Approved families
                                    by origin' }}
                                </h4>

                                <div class="ud-donut-chart-box ud-family-donut-box"
                                    (mouseleave)="onDonutMouseLeave('familyOrigin')">
                                    <dx-pie-chart [dataSource]="familyOriginData" [palette]="familyOriginPalette"
                                        [customizePoint]="customizePiePoint" type="doughnut" [innerRadius]="0.68"
                                        [size]="{ height: 135, width: 135 }"
                                        (onPointClick)="onFamilyOriginChartPointClick($event)"
                                        (onPointHoverChanged)="onDonutPointHoverChanged('familyOrigin', $event)">
                                        <dxo-size [height]="135" [width]="135"></dxo-size>
                                        <dxo-animation [enabled]="true" [duration]="600"
                                            easing="easeOutCubic"></dxo-animation>
                                        <dxo-adaptive-layout [width]="0" [height]="0"
                                            [keepLabels]="false"></dxo-adaptive-layout>
                                        <dxo-margin [top]="0" [bottom]="0" [left]="0" [right]="0"></dxo-margin>
                                        <dxi-series argumentField="name" valueField="value" tagField="color"
                                            type="doughnut" [innerRadius]="0.68">
                                            <dxo-label [visible]="false"></dxo-label>
                                        </dxi-series>
                                        <dxo-tooltip [enabled]="true" container="body" [zIndex]="999999"
                                            [customizeTooltip]="customizeTooltip"
                                            color="rgba(15, 23, 42, 0.94)" [cornerRadius]="8" [paddingTopBottom]="7"
                                            [paddingLeftRight]="11">
                                            <dxo-border color="rgba(255, 255, 255, 0.16)" [width]="1"></dxo-border>
                                            <dxo-shadow [blur]="12" color="rgba(0, 0, 0, 0.35)" [offsetX]="0"
                                                [offsetY]="4"></dxo-shadow>
                                            <dxo-font color="#ffffff" [size]="12"></dxo-font>
                                        </dxo-tooltip>
                                        <dxo-legend [visible]="false"></dxo-legend>
                                        <dxo-export [enabled]="false"></dxo-export>
                                    </dx-pie-chart>
                                    <div class="ud-donut-center-text ud-family-center"
                                        [class.ud-center-hidden]="hoveredDonut['familyOrigin']"
                                        (click)="onFamilyClick('Approved')" style="cursor: pointer;">
                                        <span class="ud-family-center-val">{{ (familyApprovedTotal || 0) | number
                                            }}</span>
                                        <span class="ud-family-center-sub">{{ langService.currentLang === 'mr' ? 'मंजूर'
                                            : 'Approved' }}</span>
                                    </div>
                                </div>

                                <!-- Origin Cards: Native & Migrated -->
                                <div class="ud-family-pills-row">
                                    <div class="ud-family-pill green" (click)="onFamilyClick('ApprovedNative')">
                                        <div class="ud-pill-top">
                                            <span class="ud-pill-dot green"></span>
                                            <span class="ud-pill-lbl">{{ langService.currentLang === 'mr' ? 'मूळ
                                                रहिवासी' : 'Native' }}</span>
                                            <span class="ud-pill-arr">
                                                <svg viewBox="0 0 24 24" width="12" height="12" fill="none"
                                                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                                    stroke-linejoin="round">
                                                    <polyline points="9 18 15 12 9 6"></polyline>
                                                </svg>
                                            </span>
                                        </div>
                                        <span class="ud-pill-big-val">{{ (familyApprovedNative || 0) | number }}</span>
                                    </div>

                                    <div class="ud-family-pill orange" (click)="onFamilyClick('ApprovedMigrated')">
                                        <div class="ud-pill-top">
                                            <span class="ud-pill-dot orange"></span>
                                            <span class="ud-pill-lbl">{{ langService.currentLang === 'mr' ? 'स्थलांतरित'
                                                : 'Migrated' }}</span>
                                            <span class="ud-pill-arr">
                                                <svg viewBox="0 0 24 24" width="12" height="12" fill="none"
                                                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                                    stroke-linejoin="round">
                                                    <polyline points="9 18 15 12 9 6"></polyline>
                                                </svg>
                                            </span>
                                        </div>
                                        <span class="ud-pill-big-val">{{ (familyApprovedMigrated || 0) | number
                                            }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 2. ELIGIBLE COUPLE FOLDER -->
                <div class="ud-card ud-ecr-card">
                    <div class="ud-card-header">
                        <div class="ud-card-title-wrap">
                            <span class="ud-card-icon-badge pink-soft">
                                <img src="assets/dashboard_icons/eligible_couple_folder.png" alt="Eligible Couple">
                            </span>
                            <span class="ud-card-title"
                                [title]="langService.currentLang === 'mr' ? 'पात्र जोडपे फोल्डर' : 'Eligible Couple Folder'">{{
                                langService.currentLang === 'mr' ? 'पात्र जोडपे फोल्डर' : 'Eligible Couple Folder'
                                }}</span>
                        </div>
                        <div class="ud-card-header-right">
                            <span class="ud-card-highlight-num">{{ ecrTotal || 0 }}</span>
                            <span class="ud-card-sublabel"
                                [title]="langService.currentLang === 'mr' ? 'एकूण पात्र जोडपे' : 'Total Eligible Couple'">{{
                                langService.currentLang === 'mr' ? 'एकूण पात्र जोडपे' : 'Total Eligible Couple'
                                }}</span>
                            <span class="ud-card-date">{{ asOnDate }}</span>
                        </div>
                    </div>

                    <div class="ud-card-body">
                        <div class="ud-ecr-wrapper-with-arrow">
                            <div class="ud-ecr-grid">
                                <!-- Top Left: Couple Protection Rate -->
                                <div class="ud-ecr-rate-card">
                                    <div class="ud-ecr-rate-content">
                                        <span class="ud-ecr-rate-title"
                                            [title]="langService.currentLang === 'mr' ? 'दंपती संरक्षण दर (CPR)' : 'Couple Protection Rate'">{{
                                            langService.currentLang === 'mr' ? 'दंपती संरक्षण दर (CPR)' : 'Couple
                                            Protection Rate' }}</span>
                                        <span class="ud-ecr-rate-num">{{ ecrProtectionRate || 0 }}%</span>
                                        <span class="ud-ecr-rate-sub"
                                            [title]="langService.currentLang === 'mr' ? ((ecrTotal || 0) + ' पैकी ' + (ecrFamilyPlanningUsage || 0) + ' पात्र जोडप्यांनी कुटुंब नियोजन पद्धत अवलंबिली आहे.') : ((ecrFamilyPlanningUsage || 0) + ' out of ' + (ecrTotal || 0) + ' eligible couples have adopted a family planning method.')">{{
                                            langService.currentLang === 'mr' ? ((ecrTotal || 0) + ' पैकी ' +
                                            (ecrFamilyPlanningUsage || 0) + ' पात्र जोडप्यांनी कुटुंब नियोजन पद्धत
                                            अवलंबिली आहे.') : ((ecrFamilyPlanningUsage || 0) + ' out of ' + (ecrTotal ||
                                            0) + ' eligible couples have adopted a family planning method.') }}</span>
                                    </div>
                                    <div class="ud-ecr-gauge"
                                        (mouseenter)="showChartTooltip($event, (langService.currentLang === 'mr' ? 'दंपती संरक्षण दर (CPR)' : 'Couple Protection Rate'), (ecrFamilyPlanningUsage || 0), '#10b981', (ecrProtectionRate || 0) + '%')"
                                        (mousemove)="moveChartTooltip($event)" (mouseleave)="hideChartTooltip()">
                                        <svg viewBox="0 0 36 36" class="circular-chart-cpr">
                                            <path class="circle-cpr-bg"
                                                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                            <path class="circle-cpr-val"
                                                [attr.stroke-dasharray]="(ecrProtectionRate || 0) + ', 100'"
                                                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                        </svg>
                                    </div>
                                </div>

                                <!-- Top Right: Sterilized Couples -->
                                <div class="ud-ecr-sterilized-card" (click)="onEcrClick('sterilized')"
                                    (mouseenter)="showChartTooltip($event, (langService.currentLang === 'mr' ? 'नसबंदी झालेली जोडपे' : 'Sterilized Couples'), (ecrSterilizedTotal || 0), '#6366f1', getEcrPercent(ecrSterilizedTotal))"
                                    (mousemove)="moveChartTooltip($event)" (mouseleave)="hideChartTooltip()">
                                    <div class="ud-ster-top-row">
                                        <div class="ud-ster-icon-box">
                                            <img src="assets/dashboard_icons/sterlized_couple.png"
                                                alt="Sterilized Couples">
                                        </div>
                                        <span class="ud-ster-title"
                                            [title]="langService.currentLang === 'mr' ? 'नसबंदी झालेली जोडपे' : 'Sterilized Couples'">{{
                                            langService.currentLang === 'mr' ? 'नसबंदी झालेली जोडपे' : 'Sterilized
                                            Couples' }}</span>
                                        <span class="ud-ster-total-num">{{ ecrSterilizedTotal || 0 }}</span>
                                    </div>

                                    <div class="ud-ster-dotted-line"></div>

                                    <div class="ud-ster-bottom-row">
                                        <div class="ud-ster-col"
                                            (click)="$event.stopPropagation(); onEcrClick('maleSterilization')"
                                            (mouseenter)="$event.stopPropagation(); showChartTooltip($event, (langService.currentLang === 'mr' ? 'पुरुष नसबंदी' : 'Male Sterilization'), (ecrMaleSterilization || 0), '#3b82f6', getSterilizationPercent(ecrMaleSterilization))"
                                            (mousemove)="moveChartTooltip($event)" (mouseleave)="hideChartTooltip()">
                                            <div class="ud-ster-col-head">
                                                <span class="ud-ster-col-val">{{ (ecrMaleSterilization || 0) | number:
                                                    '2.0-0' }}</span>
                                                <span class="ud-ster-col-lbl"
                                                    [title]="langService.currentLang === 'mr' ? 'पुरुष नसबंदी' : 'Male Sterilization'">{{
                                                    langService.currentLang === 'mr' ? 'पुरुष नसबंदी' : 'Male
                                                    Sterilization' }}</span>
                                            </div>
                                            <div class="ud-ster-bar-track">
                                                <div class="ud-ster-bar-fill"
                                                    [style.width.%]="getSterilizationFillPercent(ecrMaleSterilization)">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ud-ster-col"
                                            (click)="$event.stopPropagation(); onEcrClick('femaleSterilization')"
                                            (mouseenter)="$event.stopPropagation(); showChartTooltip($event, (langService.currentLang === 'mr' ? 'महिला नसबंदी' : 'Female Sterilization'), (ecrFemaleSterilization || 0), '#ec4899', getSterilizationPercent(ecrFemaleSterilization))"
                                            (mousemove)="moveChartTooltip($event)" (mouseleave)="hideChartTooltip()">
                                            <div class="ud-ster-col-head">
                                                <span class="ud-ster-col-val">{{ (ecrFemaleSterilization || 0) | number:
                                                    '2.0-0' }}</span>
                                                <span class="ud-ster-col-lbl"
                                                    [title]="langService.currentLang === 'mr' ? 'महिला नसबंदी' : 'Female Sterilization'">{{
                                                    langService.currentLang === 'mr' ? 'महिला नसबंदी' : 'Female
                                                    Sterilization' }}</span>
                                            </div>
                                            <div class="ud-ster-bar-track">
                                                <div class="ud-ster-bar-fill"
                                                    [style.width.%]="getSterilizationFillPercent(ecrFemaleSterilization)">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Bottom Left: Infertile Couples -->
                                <div class="ud-ecr-soft-card" (click)="onEcrClick('infertile')"
                                    [title]="langService.currentLang === 'mr' ? 'अपत्यहीन जोडपे' : 'Infertile Couples'"
                                    (mouseenter)="showChartTooltip($event, (langService.currentLang === 'mr' ? 'अपत्यहीन जोडपे' : 'Infertile Couples'), (ecrInfertileCouples || 0), '#f59e0b', getEcrPercent(ecrInfertileCouples))"
                                    (mousemove)="moveChartTooltip($event)" (mouseleave)="hideChartTooltip()">
                                    <span class="ud-ecr-soft-title">{{ langService.currentLang === 'mr' ? 'अपत्यहीन
                                        जोडपे' : 'Infertile Couples' }}</span>
                                    <span class="ud-ecr-soft-num">{{ (ecrInfertileCouples || 0) | number: '2.0-0'
                                        }}</span>
                                </div>

                                <!-- Bottom Right: Family Planning Usage -->
                                <div class="ud-ecr-soft-card ud-ecr-usage-card" (click)="onEcrClick('usage')"
                                    [title]="langService.currentLang === 'mr' ? 'कुटुंब नियोजन वापर: पद्धतीनुसार तपशील पाहण्यासाठी टॅप करा' : 'Family Planning Usage: Tap to see the method-wise breakdown'"
                                    (mouseenter)="showChartTooltip($event, (langService.currentLang === 'mr' ? 'कुटुंब नियोजन वापर' : 'Family Planning Usage'), (ecrFamilyPlanningUsage || 0), '#10b981', (ecrProtectionRate || 0) + '%')"
                                    (mousemove)="moveChartTooltip($event)" (mouseleave)="hideChartTooltip()">
                                    <div class="ud-ecr-usage-info">
                                        <span class="ud-ecr-soft-title">{{ langService.currentLang === 'mr' ? 'कुटुंब
                                            नियोजन वापर' : 'Family Planning Usage' }}</span>
                                        <span class="ud-ecr-soft-sub">{{ langService.currentLang === 'mr' ? 'पद्धतीनुसार
                                            तपशील पाहण्यासाठी टॅप करा' : 'Tap to see the method-wise breakdown'
                                            }}</span>
                                    </div>
                                    <span class="ud-ecr-soft-num">{{ ecrFamilyPlanningUsage || 0 }}</span>
                                </div>
                            </div>

                            <!-- Right Arrow -->
                            <div class="ud-ecr-right-arrow" (click)="onEcrClick('eligible')"
                                [title]="langService.currentLang === 'mr' ? 'तपशील पहा' : 'View Details'">
                                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#475569"
                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 3. ANC (Antenatal Care) -->
                <div class="ud-card" *ngIf="IsPieTempHide">
                    <div class="ud-card-header">
                        <div class="ud-card-title-wrap">
                            <span class="ud-card-icon-badge pink-soft">
                                <img src="assets/dashboard_icons/anc.png" alt="ANC">
                            </span>
                            <span class="ud-card-title">{{ langService.currentLang === 'mr' ? 'गर्भवती महिला (एएनसी)' :
                                'ANC' }}</span>
                        </div>
                        <div class="ud-card-header-right">
                            <span class="ud-card-highlight-num">{{ ancTotal || 0 }}</span>
                            <span class="ud-card-sublabel">{{ langService.currentLang === 'mr' ? 'एकूण एएनसी' : 'Total
                                ANC' }}</span>
                            <span class="ud-card-date">{{ asOnDate }}</span>
                        </div>
                    </div>

                    <div class="ud-card-body ud-donut-layout">
                        <!-- DevExtreme Donut Chart -->
                        <div class="ud-donut-chart-box" (mouseleave)="onDonutMouseLeave('anc')">
                            <dx-pie-chart [dataSource]="ancDonutData" [palette]="ancPalette"
                                [customizePoint]="customizePiePoint" type="doughnut" [innerRadius]="0.58"
                                [size]="{ height: 140, width: 140 }" (onPointClick)="onAncChartPointClick($event)"
                                (onPointHoverChanged)="onDonutPointHoverChanged('anc', $event)">
                                <dxo-size [height]="140" [width]="140"></dxo-size>
                                <dxo-animation [enabled]="true" [duration]="600" easing="easeOutCubic"></dxo-animation>
                                <dxo-adaptive-layout [width]="0" [height]="0"
                                    [keepLabels]="false"></dxo-adaptive-layout>
                                <dxo-margin [top]="0" [bottom]="0" [left]="0" [right]="0"></dxo-margin>
                                <dxi-series argumentField="name" valueField="value" tagField="color" type="doughnut"
                                    [innerRadius]="0.58">
                                    <dxo-label [visible]="false"></dxo-label>
                                </dxi-series>
                                <dxo-tooltip [enabled]="true" container="body" [zIndex]="999999"
                                    [customizeTooltip]="customizeTooltip"
                                    color="rgba(15, 23, 42, 0.94)" [cornerRadius]="8" [paddingTopBottom]="7"
                                    [paddingLeftRight]="11">
                                    <dxo-border color="rgba(255, 255, 255, 0.16)" [width]="1"></dxo-border>
                                    <dxo-shadow [blur]="12" color="rgba(0, 0, 0, 0.35)" [offsetX]="0"
                                        [offsetY]="4"></dxo-shadow>
                                    <dxo-font color="#ffffff" [size]="12"></dxo-font>
                                </dxo-tooltip>
                                <dxo-legend [visible]="false"></dxo-legend>
                                <dxo-export [enabled]="false"></dxo-export>
                            </dx-pie-chart>
                            <div class="ud-donut-center-text" [class.ud-center-hidden]="hoveredDonut['anc']">
                                <span class="ud-center-sub">{{ langService.currentLang === 'mr' ? 'एकूण एएनसी' : 'Total
                                    ANC' }}</span>
                                <span class="ud-center-val">{{ ancTotal || 0 }}</span>
                            </div>
                        </div>

                        <!-- 2-Column Chips Grid matching Figma -->
                        <div class="ud-chips-col-2x3">
                            <div class="ud-stat-pill cyan-light" (click)="onAncClick('fullyProtected')"
                                [title]="langService.currentLang === 'mr' ? 'पूर्ण संरक्षित एएनसी' : 'Fully Protected ANC'">
                                <span class="ud-dot cyan"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'पूर्ण संरक्षित एएनसी'
                                    : 'Fully Protected ANC' }}</span>
                                <span class="ud-pill-num">{{ ancFullyProtected || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill pink-light" (click)="onAncClick('normal')"
                                [title]="langService.currentLang === 'mr' ? 'सामान्य माता' : 'Normal Maata'">
                                <span class="ud-dot pink"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'सामान्य माता' :
                                    'Normal Maata' }}</span>
                                <span class="ud-pill-num">{{ ancNormalMaata || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill green-light" (click)="onAncClick('expected')"
                                [title]="langService.currentLang === 'mr' ? 'प्रसूती अपेक्षित' : 'Expected Deliveries'">
                                <span class="ud-dot green"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'प्रसूती अपेक्षित' :
                                    'Expected Deliveries' }}</span>
                                <span class="ud-pill-num">{{ ancExpectedDeliveries || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill purple-light" (click)="onAncClick('within12Weeks')"
                                [title]="langService.currentLang === 'mr' ? '१२ आठवड्यांत नोंदणीकृत गर्भधारणा' : 'Pregnancy Registered Within 12 Weeks'">
                                <span class="ud-dot purple"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? '१२ आठवड्यांत नोंदणीकृत
                                    गर्भधारणा' : 'Pregnancy Registered Within 12 Weeks' }}</span>
                                <span class="ud-pill-num">{{ ancPregnancyRegistered12Weeks || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill pink-light" (click)="onAncClick('highRisk')"
                                [title]="langService.currentLang === 'mr' ? 'उच्च जोखीम माता' : 'High-Risk Maata'">
                                <span class="ud-dot pink"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'उच्च जोखीम माता' :
                                    'High-Risk Maata' }}</span>
                                <span class="ud-pill-num">{{ ancHighRisk || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill yellow-light" (click)="onAncClick('severeAnemia')"
                                [title]="langService.currentLang === 'mr' ? 'तीव्र रक्तक्षय' : 'Severe Anemia'">
                                <span class="ud-dot yellow"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'तीव्र रक्तक्षय' :
                                    'Severe Anemia' }}</span>
                                <span class="ud-pill-num">{{ ancSevereAnemia || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 4. BIRTH REGISTER -->
                <div class="ud-card">
                    <div class="ud-card-header">
                        <div class="ud-card-title-wrap">
                            <span class="ud-card-icon-badge pink-soft">
                                <img src="assets/dashboard_icons/birth_register.png" alt="Birth Register">
                            </span>
                            <span class="ud-card-title">{{ langService.currentLang === 'mr' ? 'जन्म नोंदणी' : 'Birth
                                Register' }}</span>
                        </div>
                        <div class="ud-card-header-right">
                            <span class="ud-card-highlight-num">{{ (birthTotal || 0) | number: '2.0-0' }}</span>
                            <span class="ud-card-sublabel">{{ langService.currentLang === 'mr' ? 'एकूण नोंदणीकृत जन्म' :
                                'Total Birth Registered' }}</span>
                            <span class="ud-card-date">{{ asOnDate }}</span>
                        </div>
                    </div>

                    <div class="ud-card-body ud-birth-body">
                        <!-- Boy Card -->
                        <div class="ud-birth-item-card blue" (click)="onBirthClick('male')">
                            <div class="ud-birth-left">
                                <div class="ud-avatar-badge-circle blue">
                                    <img src="assets/dashboard_icons/boy.png" alt="Boy">
                                </div>
                                <span class="ud-birth-gender-title">{{ langService.currentLang === 'mr' ? 'मुलगा (Boy)'
                                    : 'Boy' }}</span>
                            </div>
                            <div class="ud-birth-right">
                                <span class="ud-birth-val-red">{{ (birthMale || 0) | number: '2.0-0' }}</span>
                                <span class="ud-chip-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                        </div>

                        <!-- Girl Card -->
                        <div class="ud-birth-item-card pink" (click)="onBirthClick('female')">
                            <div class="ud-birth-left">
                                <div class="ud-avatar-badge-circle pink">
                                    <img src="assets/dashboard_icons/girl.png" alt="Girl">
                                </div>
                                <span class="ud-birth-gender-title">{{ langService.currentLang === 'mr' ? 'मुलगी (Girl)'
                                    : 'Girl' }}</span>
                            </div>
                            <div class="ud-birth-right">
                                <span class="ud-birth-val-red">{{ (birthFemale || 0) | number: '2.0-0' }}</span>
                                <span class="ud-chip-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 5. HBNC REGISTER (Full Width) -->
                <div class="ud-card ud-card-full-width" *ngIf="IsPieTempHide">
                    <div class="ud-card-header">
                        <div class="ud-card-title-wrap">
                            <span class="ud-card-icon-badge pink-soft">
                                <img src="assets/dashboard_icons/hbnc.png" alt="HBNC Register">
                            </span>
                            <span class="ud-card-title">{{ langService.currentLang === 'mr' ? 'एचबीएनसी नोंदणी' : 'HBNC
                                Register' }}</span>
                        </div>
                        <div class="ud-card-header-right">
                            <span class="ud-card-highlight-num">{{ hbncTotal || 0 }}</span>
                            <span class="ud-card-sublabel"
                                [title]="langService.currentLang === 'mr' ? 'एकूण HBNC संख्या (सिस्टम जनरेटेड)' : 'Total HBNC Count (System Generated)'">{{
                                langService.currentLang === 'mr' ? 'एकूण HBNC संख्या (सिस्टम जनरेटेड)' : 'Total HBNC
                                Count (System Generated)' }}</span>
                            <span class="ud-card-date">{{ asOnDate }}</span>
                        </div>
                    </div>

                    <div class="ud-card-body ud-donut-layout">
                        <!-- DevExtreme Donut Chart -->
                        <div class="ud-donut-chart-box" (mouseleave)="onDonutMouseLeave('hbnc')">
                            <dx-pie-chart [dataSource]="hbncDonutData" [palette]="hbncPalette"
                                [customizePoint]="customizePiePoint" type="doughnut" [innerRadius]="0.68"
                                [size]="{ height: 140, width: 140 }" (onPointClick)="onHbncChartPointClick($event)"
                                (onPointHoverChanged)="onDonutPointHoverChanged('hbnc', $event)">
                                <dxo-size [height]="140" [width]="140"></dxo-size>
                                <dxo-animation [enabled]="true" [duration]="600" easing="easeOutCubic"></dxo-animation>
                                <dxo-adaptive-layout [width]="0" [height]="0"
                                    [keepLabels]="false"></dxo-adaptive-layout>
                                <dxo-margin [top]="0" [bottom]="0" [left]="0" [right]="0"></dxo-margin>
                                <dxi-series argumentField="name" valueField="value" tagField="color" type="doughnut"
                                    [innerRadius]="0.68">
                                    <dxo-label [visible]="false"></dxo-label>
                                </dxi-series>
                                <dxo-tooltip [enabled]="true" container="body" [zIndex]="999999"
                                    [customizeTooltip]="customizeTooltip"
                                    color="rgba(15, 23, 42, 0.94)" [cornerRadius]="8" [paddingTopBottom]="7"
                                    [paddingLeftRight]="11">
                                    <dxo-border color="rgba(255, 255, 255, 0.16)" [width]="1"></dxo-border>
                                    <dxo-shadow [blur]="12" color="rgba(0, 0, 0, 0.35)" [offsetX]="0"
                                        [offsetY]="4"></dxo-shadow>
                                    <dxo-font color="#ffffff" [size]="12"></dxo-font>
                                </dxo-tooltip>
                                <dxo-legend [visible]="false"></dxo-legend>
                                <dxo-export [enabled]="false"></dxo-export>
                            </dx-pie-chart>
                            <div class="ud-donut-center-text" [class.ud-center-hidden]="hoveredDonut['hbnc']">
                                <span class="ud-center-sub">{{ langService.currentLang === 'mr' ? 'एकूण HBNC संख्या' :
                                    'Total HBNC Count' }}</span>
                                <span class="ud-center-meta">{{ langService.currentLang === 'mr' ? '(सिस्टम जनरेटेड)' :
                                    '(System Generated)' }}</span>
                                <span class="ud-center-val">{{ hbncTotal || 0 }}</span>
                            </div>
                        </div>

                        <!-- 8 Pills in 2 Rows (4 in row 1, 4 in row 2) matching layout -->
                        <div class="ud-hbnc-pills-wrap">
                            <div class="ud-hbnc-row-4">
                                <div class="ud-stat-pill orange-light" (click)="onHbncClick('registered')"
                                    [title]="langService.currentLang === 'mr' ? 'एकूण नोंदणीकृत HBNC (किमान १ भेट पूर्ण)' : 'Total HBNC Registered (at least 1 visit completed)'">
                                    <span class="ud-dot orange"></span>
                                    <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'एकूण नोंदणीकृत
                                        HBNC (किमान १ भेट पूर्ण)' : 'Total HBNC Registered (at least 1 visit completed)'
                                        }}</span>
                                    <span class="ud-pill-num">{{ hbncRegistered || 0 }}</span>
                                    <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10"
                                            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg></span>
                                </div>
                                <div class="ud-stat-pill teal-light" (click)="onHbncClick('completed')"
                                    [title]="langService.currentLang === 'mr' ? 'पूर्ण झालेल्या एकूण भेटी' : 'Total Visits Completed'">
                                    <span class="ud-dot teal"></span>
                                    <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'पूर्ण झालेल्या
                                        एकूण भेटी' : 'Total Visits Completed' }}</span>
                                    <span class="ud-pill-num">{{ hbncVisitsCompleted || 0 }}</span>
                                    <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10"
                                            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg></span>
                                </div>
                                <div class="ud-stat-pill yellow-light" (click)="onHbncClick('zeroVisits')"
                                    [title]="langService.currentLang === 'mr' ? 'एकही HBNC भेट पूर्ण नाही' : 'No Visit Completed'">
                                    <span class="ud-dot yellow"></span>
                                    <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'एकही HBNC भेट
                                        पूर्ण नाही' : 'No Visit Completed' }}</span>
                                    <span class="ud-pill-num">{{ hbncZeroVisitsCompleted || 0 }}</span>
                                    <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10"
                                            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg></span>
                                </div>
                                <div class="ud-stat-pill blue-light" (click)="onHbncClick('defective')"
                                    [title]="langService.currentLang === 'mr' ? 'जन्मजात दोष असलेली मुले' : 'Defective Children'">
                                    <span class="ud-dot blue"></span>
                                    <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'जन्मजात दोष असलेली
                                        मुले' : 'Defective Children' }}</span>
                                    <span class="ud-pill-num">{{ (hbncDefectiveChildren || 0) | number: '2.0-0'
                                        }}</span>
                                    <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10"
                                            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg></span>
                                </div>
                            </div>

                            <div class="ud-hbnc-row-4">
                                <div class="ud-stat-pill cyan-light" (click)="onHbncClick('death')"
                                    [title]="langService.currentLang === 'mr' ? 'बालमृत्यू' : 'Child Death'">
                                    <span class="ud-dot cyan"></span>
                                    <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'बालमृत्यू' :
                                        'Child Death' }}</span>
                                    <span class="ud-pill-num">{{ hbncChildDeath || 0 }}</span>
                                    <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10"
                                            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg></span>
                                </div>
                                <div class="ud-stat-pill pink-light" (click)="onHbncClick('nicu')"
                                    [title]="langService.currentLang === 'mr' ? 'नवजात अतिदक्षता कक्ष' : 'NICU'">
                                    <span class="ud-dot pink"></span>
                                    <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'नवजात अतिदक्षता
                                        कक्ष' :
                                        'NICU' }}</span>
                                    <span class="ud-pill-num">{{ hbncNICU || 0 }}</span>
                                    <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10"
                                            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg></span>
                                </div>
                                <div class="ud-stat-pill purple-light" (click)="onHbncClick('kmc')"
                                    [title]="langService.currentLang === 'mr' ? 'नवजात स्थिरीकरण कक्ष' : 'NBSU'">
                                    <span class="ud-dot purple"></span>
                                    <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'नवजात स्थिरीकरण
                                        कक्ष' :
                                        'NBSU' }}</span>
                                    <span class="ud-pill-num">{{ hbncNBSU || 0 }}</span>
                                    <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10"
                                            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg></span>
                                </div>
                                <div class="ud-stat-pill lilac-light" (click)="onHbncClick('sncu')"
                                    [title]="langService.currentLang === 'mr' ? 'विशेष नवजात शिशु उपचार कक्ष' : 'SNCU'">
                                    <span class="ud-dot purple"></span>
                                    <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'विशेष नवजात शिशु
                                        उपचार कक्ष' :
                                        'SNCU' }}</span>
                                    <span class="ud-pill-num">{{ (hbncSNCU || 0) | number: '2.0-0' }}</span>
                                    <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10"
                                            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 6. CHILD IMMUNIZATION -->
                <div class="ud-card" *ngIf="IsPieTempHide">
                    <div class="ud-card-header">
                        <div class="ud-card-title-wrap">
                            <span class="ud-card-icon-badge pink-soft">
                                <img src="assets/dashboard_icons/child_immunization.png" alt="Child Immunization">
                            </span>
                            <span class="ud-card-title"
                                [title]="langService.currentLang === 'mr' ? 'लसीकरण आढावा' : 'Child Immunization'">{{
                                langService.currentLang === 'mr' ? 'लसीकरण आढावा' : 'Child Immunization' }}</span>
                        </div>
                        <div class="ud-card-header-right">
                            <span class="ud-card-highlight-num">{{ immunizationTotal || 0 }}</span>
                            <span class="ud-card-sublabel"
                                [title]="langService.currentLang === 'mr' ? 'एकूण मुले' : 'Total Children'">{{
                                langService.currentLang === 'mr' ? 'एकूण मुले' : 'Total Children' }}</span>
                            <span class="ud-card-date">{{ asOnDate }}</span>
                        </div>
                    </div>

                    <div class="ud-card-body ud-immunization-layout">
                        <!-- Left Chart with Y-axis matching Figma -->
                        <!-- DevExtreme Bar Chart -->
                        <div class="ud-imm-chart-col">
                            <span class="ud-imm-chart-title"
                                [title]="langService.currentLang === 'mr' ? 'लसीकरण स्थिती' : 'Immunization Status'">{{
                                langService.currentLang === 'mr' ? 'लसीकरण स्थिती' : 'Immunization Status' }}</span>
                            <dx-chart [dataSource]="immunizationChartData" [size]="{ height: 165, width: 215 }"
                                [customizePoint]="customizeImmunizationPoint"
                                (onPointClick)="onImmunizationChartPointClick($event)">
                                <dxo-size [height]="165" [width]="215"></dxo-size>
                                <dxo-animation [enabled]="true" [duration]="600" easing="easeOutCubic"></dxo-animation>
                                <dxo-adaptive-layout [width]="0" [height]="0"
                                    [keepLabels]="false"></dxo-adaptive-layout>
                                <dxo-margin [top]="8" [bottom]="4" [left]="4" [right]="4"></dxo-margin>
                                <dxo-common-series-settings argumentField="name" tagField="color" type="bar">
                                    <dxo-label [visible]="true" position="outside">
                                        <dxo-font [size]="10" [weight]="700" color="#334155"></dxo-font>
                                    </dxo-label>
                                </dxo-common-series-settings>
                                <dxi-series valueField="value" argumentField="name" name="Immunization"></dxi-series>
                                <dxo-legend [visible]="false"></dxo-legend>
                                <dxo-tooltip [enabled]="true" container="body" [zIndex]="999999"
                                    [customizeTooltip]="customizeImmunizationTooltip"
                                    color="rgba(15, 23, 42, 0.94)" [cornerRadius]="8" [paddingTopBottom]="7"
                                    [paddingLeftRight]="11">
                                    <dxo-border color="rgba(255, 255, 255, 0.16)" [width]="1"></dxo-border>
                                    <dxo-shadow [blur]="12" color="rgba(0, 0, 0, 0.35)" [offsetX]="0"
                                        [offsetY]="4"></dxo-shadow>
                                    <dxo-font color="#ffffff" [size]="12"></dxo-font>
                                </dxo-tooltip>
                                <dxo-argument-axis [visible]="true">
                                    <dxo-label [wordWrap]="'normal'" [alignment]="'center'">
                                        <dxo-font [size]="9" [weight]="600" color="#64748b"></dxo-font>
                                    </dxo-label>
                                </dxo-argument-axis>
                                <dxo-value-axis [visible]="false"></dxo-value-axis>
                            </dx-chart>
                        </div>

                        <!-- Right Stacked Cards -->
                        <div class="ud-imm-cards-col">
                            <div class="ud-stat-pill green-light" (click)="onImmunizationClick('fully')"
                                [title]="langService.currentLang === 'mr' ? 'पूर्ण लसीकरण झालेली मुले' : 'Fully Immunized Children'">
                                <span class="ud-dot green"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'पूर्ण लसीकरण झालेली
                                    मुले' : 'Fully Immunized Children' }}</span>
                                <span class="ud-pill-num">{{ immunizationFully || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill blue-light" (click)="onImmunizationClick('noVaccine')"
                                [title]="langService.currentLang === 'mr' ? 'लसीकरण सुरू न झालेली मुले' : 'Children with no Vaccination Started'">
                                <span class="ud-dot blue"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'लसीकरण सुरू न झालेली
                                    मुले' : 'Children with no Vaccination Started' }}</span>
                                <span class="ud-pill-num">{{ immunizationNoVaccine || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill orange-light" (click)="onImmunizationClick('startedNotCompleted')"
                                [title]="langService.currentLang === 'mr' ? 'लसीकरण सुरू पण अपूर्ण' : 'Immunization Started but not Completed'">
                                <span class="ud-dot orange"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'लसीकरण सुरू पण अपूर्ण'
                                    : 'Immunization Started but not Completed' }}</span>
                                <span class="ud-pill-num">{{ immunizationStartedNotCompleted || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 7. DEATH REGISTER -->
                <div class="ud-card" *ngIf="IsPieTempHide">
                    <div class="ud-card-header">
                        <div class="ud-card-title-wrap">
                            <span class="ud-card-icon-badge pink-soft">
                                <img src="assets/dashboard_icons/death_register.png" alt="Death Register">
                            </span>
                            <span class="ud-card-title">{{ langService.currentLang === 'mr' ? 'मृत्यू नोंदवही' : 'Death
                                Register' }}</span>
                        </div>
                        <div class="ud-card-header-right">
                            <span class="ud-card-highlight-num">{{ deathTotal || 0 }}</span>
                            <span class="ud-card-sublabel">{{ langService.currentLang === 'mr' ? 'एकूण मृत्यू' : 'Total
                                Death' }}</span>
                            <span class="ud-card-date">{{ asOnDate }}</span>
                        </div>
                    </div>

                    <div class="ud-card-body ud-donut-layout">
                        <!-- DevExtreme Donut Chart -->
                        <div class="ud-donut-chart-box" (mouseleave)="onDonutMouseLeave('death')">
                            <dx-pie-chart [dataSource]="deathDonutData" [palette]="deathPalette"
                                [customizePoint]="customizePiePoint" type="doughnut" [innerRadius]="0.58"
                                [size]="{ height: 140, width: 140 }" (onPointClick)="onDeathChartPointClick($event)"
                                (onPointHoverChanged)="onDonutPointHoverChanged('death', $event)">
                                <dxo-size [height]="140" [width]="140"></dxo-size>
                                <dxo-animation [enabled]="true" [duration]="600" easing="easeOutCubic"></dxo-animation>
                                <dxo-adaptive-layout [width]="0" [height]="0"
                                    [keepLabels]="false"></dxo-adaptive-layout>
                                <dxo-margin [top]="0" [bottom]="0" [left]="0" [right]="0"></dxo-margin>
                                <dxi-series argumentField="name" valueField="value" tagField="color" type="doughnut"
                                    [innerRadius]="0.58">
                                    <dxo-label [visible]="false"></dxo-label>
                                </dxi-series>
                                <dxo-tooltip [enabled]="true" container="body" [zIndex]="999999"
                                    [customizeTooltip]="customizeTooltip"
                                    color="rgba(15, 23, 42, 0.94)" [cornerRadius]="8" [paddingTopBottom]="7"
                                    [paddingLeftRight]="11">
                                    <dxo-border color="rgba(255, 255, 255, 0.16)" [width]="1"></dxo-border>
                                    <dxo-shadow [blur]="12" color="rgba(0, 0, 0, 0.35)" [offsetX]="0"
                                        [offsetY]="4"></dxo-shadow>
                                    <dxo-font color="#ffffff" [size]="12"></dxo-font>
                                </dxo-tooltip>
                                <dxo-legend [visible]="false"></dxo-legend>
                                <dxo-export [enabled]="false"></dxo-export>
                            </dx-pie-chart>
                            <div class="ud-donut-center-text" [class.ud-center-hidden]="hoveredDonut['death']">
                                <span class="ud-center-sub">{{ langService.currentLang === 'mr' ? 'एकूण मृत्यू' : 'Total
                                    Death' }}</span>
                                <span class="ud-center-val">{{ deathTotal || 0 }}</span>
                            </div>
                        </div>

                        <!-- 2-Column Chips Grid matching Figma -->
                        <div class="ud-chips-col-2x3">
                            <div class="ud-stat-pill cyan-light" (click)="onDeathClick('anc')">
                                <span class="ud-dot cyan"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'गर्भावस्थेतील मृत्यू
                                    (ANC)' : 'ANC Death' }}</span>
                                <span class="ud-pill-num">{{ deathANC || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill purple-light" (click)="onDeathClick('still')">
                                <span class="ud-dot purple"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'मृत जन्म (Still
                                    Birth)' : 'Still Birth' }}</span>
                                <span class="ud-pill-num">{{ deathStillBirth || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill blue-light" (click)="onDeathClick('0to5')">
                                <span class="ud-dot blue"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? '०-५ वर्षे वयोगटातील
                                    मृत्यू' : '0-5 Years Death' }}</span>
                                <span class="ud-pill-num">{{ death0to5Years || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill purple-light" (click)="onDeathClick('30plus')">
                                <span class="ud-dot purple"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? '३०+ वर्षे वयोगटातील
                                    मृत्यू' : '30+ Year Death' }}</span>
                                <span class="ud-pill-num">{{ death30PlusYears || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill red-light" (click)="onDeathClick('65plus')">
                                <span class="ud-dot red"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? '६५+ वर्षे वयोगटातील
                                    मृत्यू' : '65+ Year Death' }}</span>
                                <span class="ud-pill-num">{{ death65PlusYears || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 8. PNC (Postnatal Care) -->
                <div class="ud-card" *ngIf="IsPieTempHide">
                    <div class="ud-card-header">
                        <div class="ud-card-title-wrap">
                            <span class="ud-card-icon-badge pink-soft">
                                <img src="assets/dashboard_icons/pnc.png" alt="PNC">
                            </span>
                            <span class="ud-card-title">{{ langService.currentLang === 'mr' ? 'प्रसूतीनंतरची काळजी
                                (पीएनसी)' : 'PNC' }}</span>
                        </div>
                        <div class="ud-card-header-right">
                            <span class="ud-card-highlight-num">{{ pncTotal || 0 }}</span>
                            <span class="ud-card-sublabel"
                                [title]="langService.currentLang === 'mr' ? 'एकूण PNC संख्या (सिस्टम जनरेटेड)' : 'Total PNC Count (System Generated)'">{{
                                langService.currentLang === 'mr' ? 'एकूण PNC संख्या (सिस्टम जनरेटेड)' : 'Total PNC Count
                                (System Generated)' }}</span>
                            <span class="ud-card-date">{{ asOnDate }}</span>
                        </div>
                    </div>

                    <div class="ud-card-body ud-donut-layout">
                        <!-- DevExtreme Donut Chart -->
                        <div class="ud-donut-chart-box" (mouseleave)="onDonutMouseLeave('pnc')">
                            <dx-pie-chart [dataSource]="pncDonutData" [palette]="pncPalette"
                                [customizePoint]="customizePiePoint" type="doughnut" [innerRadius]="0.68"
                                [size]="{ height: 140, width: 140 }" (onPointClick)="onPncChartPointClick($event)"
                                (onPointHoverChanged)="onDonutPointHoverChanged('pnc', $event)">
                                <dxo-size [height]="140" [width]="140"></dxo-size>
                                <dxo-animation [enabled]="true" [duration]="600" easing="easeOutCubic"></dxo-animation>
                                <dxo-adaptive-layout [width]="0" [height]="0"
                                    [keepLabels]="false"></dxo-adaptive-layout>
                                <dxo-margin [top]="0" [bottom]="0" [left]="0" [right]="0"></dxo-margin>
                                <dxi-series argumentField="name" valueField="value" tagField="color" type="doughnut"
                                    [innerRadius]="0.68">
                                    <dxo-label [visible]="false"></dxo-label>
                                </dxi-series>
                                <dxo-tooltip [enabled]="true" container="body" [zIndex]="999999"
                                    [customizeTooltip]="customizeTooltip"
                                    color="rgba(15, 23, 42, 0.94)" [cornerRadius]="8" [paddingTopBottom]="7"
                                    [paddingLeftRight]="11">
                                    <dxo-border color="rgba(255, 255, 255, 0.16)" [width]="1"></dxo-border>
                                    <dxo-shadow [blur]="12" color="rgba(0, 0, 0, 0.35)" [offsetX]="0"
                                        [offsetY]="4"></dxo-shadow>
                                    <dxo-font color="#ffffff" [size]="12"></dxo-font>
                                </dxo-tooltip>
                                <dxo-legend [visible]="false"></dxo-legend>
                                <dxo-export [enabled]="false"></dxo-export>
                            </dx-pie-chart>
                            <div class="ud-donut-center-text" [class.ud-center-hidden]="hoveredDonut['pnc']">
                                <span class="ud-center-sub">{{ langService.currentLang === 'mr' ? 'एकूण PNC संख्या' :
                                    'Total PNC Count' }}</span>
                                <span class="ud-center-meta">{{ langService.currentLang === 'mr' ? '(सिस्टम जनरेटेड)' :
                                    '(System Generated)' }}</span>
                                <span class="ud-center-val">{{ pncTotal || 0 }}</span>
                            </div>
                        </div>

                        <div class="ud-imm-cards-col">
                            <div class="ud-stat-pill teal-light" (click)="onPncClick('completed')"
                                [title]="langService.currentLang === 'mr' ? 'एकूण नोंदणीकृत PNC (किमान १ भेट पूर्ण)' : 'Total PNC Registered (at least 1 visit completed)'">
                                <span class="ud-dot teal"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'एकूण नोंदणीकृत PNC
                                    (किमान १ भेट पूर्ण)' : 'Total PNC Registered (at least 1 visit completed)' }}</span>
                                <span class="ud-pill-num">{{ pncVisitsCompleted || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill yellow-light" (click)="onPncClick('zeroVisits')"
                                [title]="langService.currentLang === 'mr' ? 'एकही PNC भेट पूर्ण नाही' : 'No Visit Completed'">
                                <span class="ud-dot yellow"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'एकही PNC भेट पूर्ण
                                    नाही' : 'No Visit Completed' }}</span>
                                <span class="ud-pill-num">{{ pncZeroVisitCompleted || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill purple-light" (click)="onPncClick('highRisk')">
                                <span class="ud-dot purple"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'उच्च जोखीम PNC' :
                                    'High-Risk PNC' }}</span>
                                <span class="ud-pill-num">{{ pncHighRisk || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                            <div class="ud-stat-pill green-light" (click)="onPncClick('normal')">
                                <span class="ud-dot green"></span>
                                <span class="ud-pill-text">{{ langService.currentLang === 'mr' ? 'सामान्य PNC' : 'Normal
                                    PNC' }}</span>
                                <span class="ud-pill-num">{{ pncNormal || 0 }}</span>
                                <span class="ud-pill-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- 9. PREGNANCY LOSS -->
                <div class="ud-card">
                    <div class="ud-card-header">
                        <div class="ud-card-title-wrap">
                            <span class="ud-card-icon-badge pink-soft">
                                <img src="assets/dashboard_icons/pregnancy_loss.png" alt="Pregnancy Loss">
                            </span>
                            <span class="ud-card-title">{{ langService.currentLang === 'mr' ? 'गर्भधारणा हानी' :
                                'Pregnancy
                                Loss' }}</span>
                        </div>
                        <div class="ud-card-header-right">
                            <span class="ud-card-highlight-num">{{ (pregnancyLossTotal || 0) | number: '2.0-0' }}</span>
                            <span class="ud-card-sublabel">{{ langService.currentLang === 'mr' ? 'एकूण गर्भधारणा हानी' :
                                'Total pregnancy Loss' }}</span>
                            <span class="ud-card-date">{{ asOnDate }}</span>
                        </div>
                    </div>

                    <div class="ud-card-body ud-birth-body">
                        <!-- Abortion -->
                        <div class="ud-birth-item-card pink-soft" (click)="onPregnancyLossClick('abortion')">
                            <div class="ud-birth-left">
                                <div class="ud-avatar-badge-circle pink-soft">
                                    <img src="assets/dashboard_icons/abortion.png" alt="Abortion">
                                </div>
                                <span class="ud-birth-gender-title">{{ langService.currentLang === 'mr' ? 'वैद्यकीय
                                    गर्भपात' :
                                    'Abortion' }}</span>
                            </div>
                            <div class="ud-birth-right">
                                <span class="ud-birth-val-red">{{ (pregnancyLossAbortion || 0) | number: '2.0-0'
                                    }}</span>
                                <span class="ud-chip-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                        </div>

                        <!-- Miscarriage -->
                        <div class="ud-birth-item-card pink-soft" (click)="onPregnancyLossClick('miscarriage')">
                            <div class="ud-birth-left">
                                <div class="ud-avatar-badge-circle pink-soft">
                                    <img src="assets/dashboard_icons/miscarriage.png" alt="Miscarriage">
                                </div>
                                <span class="ud-birth-gender-title">{{ langService.currentLang === 'mr' ? 'नैसर्गिक
                                    गर्भपात' :
                                    'Miscarriage' }}</span>
                            </div>
                            <div class="ud-birth-right">
                                <span class="ud-birth-val-red">{{ (pregnancyLossMiscarriage || 0) | number: '2.0-0'
                                    }}</span>
                                <span class="ud-chip-arrow"><svg viewBox="0 0 24 24" width="10" height="10" fill="none"
                                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg></span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

    </ng-container>

    <!-- GLOBAL FLOATING CHART TOOLTIP -->
    <div class="ud-chart-tooltip" *ngIf="chartTooltip.visible" [ngStyle]="chartTooltipStyle">
        <div class="ud-tooltip-header">
            <span class="ud-tooltip-dot" [style.background-color]="chartTooltip.color"></span>
            <span class="ud-tooltip-title">{{ chartTooltip.title }}</span>
        </div>
        <div class="ud-tooltip-body">
            <span class="ud-tooltip-value">{{ chartTooltip.value }}</span>
            <span class="ud-tooltip-percent" *ngIf="chartTooltip.percent">{{ chartTooltip.percent.startsWith('(') ?
                chartTooltip.percent : '(' + chartTooltip.percent + ')' }}</span>
        </div>
    </div>

</div>